export interface SubmitResult {
  ok: boolean;
  message: string;
}

interface FormApiResponse {
  code?: string;
  message?: string;
  meta?: {
    message?: string;
    detail?: string;
  };
}

export async function submitFormData(
  url: string,
  formEl: HTMLFormElement,
  successMessage: string
): Promise<SubmitResult> {
  const formData = new FormData(formEl);
  const honeypot = String(formData.get("website_alt") ?? "").trim();
  if (honeypot) {
    return { ok: true, message: successMessage };
  }
  formData.delete("website_alt");

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    if (typeof value === "string") {
      body.append(key, value);
    }
  });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });

    const responseText = await response.text();
    let parsed: FormApiResponse | null = null;
    try {
      parsed = JSON.parse(responseText) as FormApiResponse;
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
    const code = parsed?.code;
    const isSpam = /spam|form data is spam/i.test(String(serverMsg));

    if (!response.ok || (code && code !== "OK") || isSpam) {
      return { ok: false, message: serverMsg || "提交失败，请稍后重试。" };
    }

    return { ok: true, message: successMessage };
  } catch {
    return { ok: false, message: "网络异常，请稍后重试。" };
  }
}